module.exports = __webpack_public_path__ + "img/qx_action.6eaafc65.png";